const userProfile = {
    userProfile: {
        caption: 'Meu Perfil',
    }
};

export default userProfile;
